import config from "flow/config";
import { Session } from "flow/session/session";
import activator from "flow/utils/activator";
import localStorageChannel from "flow/session/localStorageChannel";
import UnsavedDataEnum from "flow/session/UnsavedDataEnum";
import bind from "bind-decorator";

export default class SessionMonitor {
    constructor(private readonly session: Session) {}

    isWorkspaceDirty() {
        return !activator.canLeaveSweepWithoutUserFeedback();
    }

    subscribeToLogouts() {
        localStorageChannel.subscribe(config.storageChannelTopics.logout, this.onLogoutEvent);
        localStorageChannel.subscribe(config.storageChannelTopics.unsavedData, this.onUnsavedDataEvent);
        localStorageChannel.subscribe(config.storageChannelTopics.reload, this.onReloadEvent);
    }

    unsubscribeToStorage() {
        localStorageChannel.unsubscribe(config.storageChannelTopics.logout, this.onLogoutEvent);
        localStorageChannel.unsubscribe(config.storageChannelTopics.unsavedData, this.onUnsavedDataEvent);
        localStorageChannel.unsubscribe(config.storageChannelTopics.reload, this.onReloadEvent);
    }

    @bind
    private onLogoutEvent(message: string) {
        if (message === config.forceLogoutMessage) {
            this.session.forceLogout(false);
        }
    }

    @bind
    private onUnsavedDataEvent(message: string) {
        if (message === UnsavedDataEnum.Query) {
            if (this.isWorkspaceDirty()) {
                localStorageChannel.publish(config.storageChannelTopics.unsavedData, UnsavedDataEnum.HasUnsavedData);
            }
        }
    }

    @bind
    private onReloadEvent() {
        this.session.forceReload();
    }
}
